/*This function gets root document and createRoot() controls 
  the contents of the container node you pass in. Any existing DOM 
  elements inside are replaced when render is called. Later calls 
  use React’s DOM diffing algorithm for efficient updates.
  <HashRouter> makes it possible to store the current location 
  in the hash portion of the current URL, so it is never sent to the server.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { CookiesProvider } from "react-cookie";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {  BrowserRouter as Router} from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  console.log("MSAL Initialized Successfully! ");

  root.render(
    <Router basename="/">
      <CookiesProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </CookiesProvider>
    </Router>
  );

  serviceWorkerRegistration.unregister(); // ✅ This disables service worker
}).catch(error => {
  console.error("MSAL Initialization Failed :", error);
});